import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Contact } from '../../../classes';
import { ContactInformationTypeIconPipe } from '../../../pipes/contact-information-type-icon.pipe';
import { ContactInformationTypeNamePipe } from '../../../pipes/contact-information-type-name.pipe';
import { ContactService } from '../../../services/contact.service';

@Component({
  selector: 'app-contact-label',
  templateUrl: './contact-label.component.html',
  styleUrls: ['./contact-label.component.css'],
  providers: [
    ContactInformationTypeIconPipe,
    ContactInformationTypeNamePipe
  ]
})
export class ContactLabelComponent implements OnChanges, OnInit {

  entries = [];

  @Input() contactIdentifier: number;
  @Input() headline: string;

  contact: Contact;

  constructor(
    private _contactService: ContactService,
    private _contactInformationTypeIconPipe: ContactInformationTypeIconPipe,
    private _contactInformationTypeNamePipe: ContactInformationTypeNamePipe
  ) { }

  loadContact() {
    this._contactService.getContactById(this.contactIdentifier, true).subscribe({
      next: (contact) => {
        this.contact = contact;
        this.updateEntries();
      }
    });
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges['contactIdentifier']) this.loadContact();
  }

  ngOnInit(): void {
    this.loadContact();
  }

  updateEntries() {
    this.entries = [];
    if (this.contact && Array.isArray(this.contact.contactinformation)) {
      for (let info of this.contact.contactinformation) {

        let entry = {
          icon: this._contactInformationTypeIconPipe.transform(info.infotype),
          type: this._contactInformationTypeNamePipe.transform(info.infotype),
          value: info.infovalue
        };

        this
          .entries
          .push(entry);
      }
    }
  }
}
